import React from "react";

import { useIntl } from "react-intl";

import { Alert, Button } from "@mapmycustomers/ui";

import styles from "./SsoAlert.module.scss";

interface Props {}

const SsoAlert: React.FC<Props> = () => {
  const intl = useIntl();

  return (
    <Alert
      action={
        <Button
          href="https://share.hsforms.com/1aoERY4lrQ0GOQeRlXahNAQ3is1h"
          target="_blank"
          type="primary"
        >
          {intl.formatMessage({
            id: "settings.organizationDetails.data.sso.alert.action",
            defaultMessage: "Enable SSO",
            description: "Alert link on the Integration page",
          })}
        </Button>
      }
      className={styles.alert}
      description={intl.formatMessage({
        id: "settings.organizationDetails.data.sso.alert.description",
        defaultMessage:
          "SSO simplifies and streamlines user access to multiple applications with one login, improving convenience and productivity while enhancing security by minimizing password-related risks. Inquire with your account team how to make SSO available for you.",
        description: "Alert description on the Org settings for SSO",
      })}
      message={intl.formatMessage({
        id: "settings.organizationDetails.data.sso.alert.title",
        defaultMessage: "Automatically add SSO sign-in users to your organization",
        description: "Alert title on the Org settings for SSO",
      })}
      type="info"
    />
  );
};

export default SsoAlert;
